import React from 'react'
import {Link} from "react-router-dom";

const Profile = () => {
    const profile = {

        profileImage: 'assets/images/masoud-codes.gif',

        cv: 'assets/cv/CV_currently.pdf',
    
        background: 'assets/images/cc-bg-1.jpg',
    
        fullName: 'Sharifu .H. Masudi',
    
        age: new Date().getFullYear() - 1997,
    
        email: 'sharifumasudi66@gmail.com',
    
        phone: '+255622183130',
    
        altenateImage: "image profile",
    
        addres: 'P.O.BOX 3000, Morogoro Tanzania',
    
        language: 'English, Swahili',
    
        aboutTitle: 'Web Developer, System developer Graphic Designer,  Mobile App developer',
    
        aboutDetails: `
        Innovative tech professional with 3+ years of experience working as a computer programmer. Capable of working with a
        variety of technology and software solutions and managing databases. Valuable team member who has experience
        diagnosing problems and developing solutions. Extensive expertise in networking systems and working with mainframe
        computers. Talented leader with unique ideas and a history of successful contributions in the field.
        `
      }
  return (

    <div className="profile-page">
        <div className="wrapper">
        <div className="page-header page-header-small" filter-color="green">
            <div className="page-header-image" data-parallax="true" 

            style={{ backgroundImage: `url(${profile.background})` }}>

            </div>
            <div className="container">
            <div className="content-center">
                <div className="cc-profile-image"><a href="#"><img src={profile.profileImage} alt={profile.altenateImage}/></a></div>
                <div className="h2 title">{profile.fullName}</div>
                <p className="category text-white">{profile.aboutTitle}</p>
                <Link className="btn btn-primary mr-2" to="/contact-me">Hire Me</Link>
                <a href={profile.cv} download className="btn btn-primary" data-aos="zoom-in" data-aos-anchor="data-aos-anchor">Download CV</a>
            </div>
            </div>
            <div className="section">
            <div className="container">
                <div className="button-container">
                    <a className="btn btn-default btn-round btn-lg btn-icon" href="https://www.linkedin.com/in/sharifu-hamisi-masudi-159690182" rel="tooltip" title="Follow me on Linkedin"><i className="fa fa-linkedin"></i>
                    </a>
                    <a className="btn btn-default btn-round btn-lg btn-icon" href="https://github.com/sharifumasudi" rel="tooltip" title="Follow me on Google+"><i className="fa fa-google-plus"></i>
                    </a>
                    <a className="btn btn-default btn-round btn-lg btn-icon" href="https://github.com/sharifumasudi" rel="tooltip" title="Follow me on Github"><i className="fa fa-github"></i>
                    </a>
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>
  )
}

export default Profile
